import { useEffect } from "react";

export function useParallax(ref, strength = 8) {
    useEffect(() => {
        const el = ref.current;
        if (!el || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

        let raf = 0;
        let tx = 0;
        let ty = 0;
        let x = 0;
        let y = 0;

        const tick = () => {
            x += (tx - x) * 0.07;
            y += (ty - y) * 0.07;
            el.style.setProperty("--look-x", x.toFixed(2));
            el.style.setProperty("--look-y", y.toFixed(2));
            raf = requestAnimationFrame(tick);
        };

        const move = (event) => {
            tx = (event.clientX / window.innerWidth - 0.5) * strength;
            ty = (event.clientY / window.innerHeight - 0.5) * strength;
        };

        window.addEventListener("pointermove", move, { passive: true });
        raf = requestAnimationFrame(tick);

        return () => {
            window.removeEventListener("pointermove", move);
            cancelAnimationFrame(raf);
        };
    }, [ref, strength]);
}
